// Module
var code = "<div class=\"SubmitClaimPageHeader\"> <mx-back-button ng-if=\"SubmitClaimPageHeader.showBackButton\" click=\"SubmitClaimPageHeader.back()\"></mx-back-button> <div class=\"SubmitClaimPageHeader__closeContainer\"> <a class=\"SubmitClaimPageHeader__close\" ui-sref=\"Activity\"> {{ SubmitClaimPageHeader.closeText }} </a> </div> </div> ";
// Exports
var _module_exports = code;;
var path = '@collectivehealth/frontend-member-v2/pages/activity/submitClaim/submitClaimPageHeader/submitClaimPageHeader.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;